import { useRef, useEffect } from 'react';
import { pushGTMLocationsDisplayedEvent } from 'utils/gtm';
import pushGTMWithDelay from 'utils/pushGTMWithDelay';

/**
 * Tracking user interactions with FindLocation section
 */
export function useUserInteractions() {
  const contentWrapperRef = useRef(null);
  const eventPropagatedRef = useRef(null);

  useEffect(() => {
    const gtmEvent = () => {
      if (eventPropagatedRef.current === 'propagated') return;
      // trigger GTM event 'Locations Displayed'
      pushGTMWithDelay(33, pushGTMLocationsDisplayedEvent, { service: 'INS' });
      eventPropagatedRef.current = 'propagated';
    };

    contentWrapperRef?.current?.addEventListener('pointerup', gtmEvent);

    return () => {
      contentWrapperRef?.current?.removeEventListener('pointerup', gtmEvent);
    };
  }, []);

  return { contentWrapperRef };
}
